// Slim cluster-metadata reads. Currently just the distinct block list,
// used to power the block-filter chip on the complaints list.

import { api } from './api-client';

export async function listClusterBlocks(): Promise<string[]> {
  const { data } = await api.get<{ blocks: string[] }>('/cluster/blocks');
  return data.blocks;
}

export interface ClusterConfig {
  name: string;
  hero_image_url: string | null;
}

export async function getClusterConfig(): Promise<ClusterConfig> {
  const { data } = await api.get<ClusterConfig>('/cluster/config');
  return data;
}

export async function putClusterBranding(hero_image_url: string | null): Promise<ClusterConfig> {
  const { data } = await api.put<ClusterConfig>('/cluster/branding', { hero_image_url });
  return data;
}
